import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import Modal from 'components/Modal';

import { injectIntl } from 'react-intl';
import { find as _find } from 'lodash';

import CmsPage from 'components/CmsPage';

import Tabs from 'components/layout/Tabs';

class PluginDetails extends React.Component {
  getTabHeaderList = () => {
    const {
      intl: { messages },
    } = this.props;
    const result = [];

    result.push(messages.plugin);
    result.push(messages.prices);
    result.push(messages.installation_instructions);
    result.push(messages.terms_of_use);

    return result;
  };

  getTabContentList = () => {
    const { appIntl, plugin } = this.props;
    const result = [];

    const detailedDescriptionContent = _find(plugin.detailed_description, ['language', appIntl.displayIntlForm]);
    const pricelistContent = _find(plugin.pricelist, ['language', appIntl.displayIntlForm]);
    const installationInstructionsContent = _find(plugin.installation_instructions, [
      'language',
      appIntl.displayIntlForm,
    ]);
    const termsOfUseContent = _find(plugin.terms_of_use, ['language', appIntl.displayIntlForm]);

    result.push(<CmsPage data={detailedDescriptionContent || {}} doUpdateActiveCms={false} doUpdateDocMeta={false} />);
    result.push(<CmsPage data={pricelistContent || {}} doUpdateActiveCms={false} doUpdateDocMeta={false} />);
    result.push(
      <CmsPage data={installationInstructionsContent || {}} doUpdateActiveCms={false} doUpdateDocMeta={false} />
    );
    result.push(<CmsPage data={termsOfUseContent || {}} doUpdateActiveCms={false} doUpdateDocMeta={false} />);

    return result;
  };

  renderContent = () => {
    const {
      intl: { messages },
      plugin,
      mayActivate,
      onActivate,
    } = this.props;

    return plugin ? (
      <div>
        {mayActivate && (
          <div class="text-right">
            <Button onClick={onActivate}>{messages.activate_plugin}</Button>
          </div>
        )}

        <div class="">
          <Tabs tabs={this.getTabHeaderList()} tabContent={this.getTabContentList()} keepMounted={[]} />
        </div>
      </div>
    ) : null;
  };

  render() {
    const { show, close, plugin, useModal } = this.props;

    if (!useModal) {
      return this.renderContent();
    }

    return plugin ? (
      <Modal show={show} onHide={close} bsSize="lg" class="full-width">
        <Modal.Header closeButton>
          <Modal.Title>{plugin.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{this.renderContent()}</Modal.Body>
      </Modal>
    ) : null;
  }
}
PluginDetails.defaultProps = {
  useModal: true,
  close: () => {},
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(PluginDetails)));
